import { navigate } from "gatsby"
import React, { memo } from "react"
import { appNavigate } from "../../../../utils/functions"
import OptimizedImage from "../../../ImageShow/OptimizedImage"
import MoreButtonArrowIcon from "../../../svg/MoreButtonArrowIcon"
import * as styles from "./resources.module.css"
import * as style from "./whatWeDoMenu.module.css"

const SubmenuList = ({ Dynamic, SubItem }) => {
  const className = Dynamic ? style.what_we_do_menu : ""

  function removeClass(links) {
    document.body.classList.remove("body-class-open")
    navigate(links)
  }

  return (
    <div className={`${className}`}>
      {SubItem?.map(val => {
        return (
          val.menuSubMenuItems == "yes" && (
            <>
              {val.menuSubMenuList?.map(data => {
                return (
                  <div
                    key={data.menuSubMenuTitle}
                    className={`${style.tech_sub_menu_wrap} ${data.menuSubMenuTitle}Menu`}
                  >
                    <span
                      className={style.heading_text}
                      onClick={() =>
                        data.subMenuTitleHasLink === "yes"
                          ? removeClass(data.menuSubMenuLink?.uri)
                          : ""
                      }
                    >
                      {data.menuSubMenuTitle}
                    </span>
                    <div className={style.inner_menu}>
                      <div className={style.menuBox}>
                        {data?.menuSubSubMenuList.map(res => {
                          return (
                            <a
                              key={res.menuSubSubMenuTitle}
                              onClick={e => {
                                e.preventDefault()
                                appNavigate(res.menuSubSubMenuLink?.uri)
                                removeClass()
                              }}
                              href={res.menuSubSubMenuLink?.uri}
                              className={`${style.tech_sub_menu_box}
                                ${
                                  val.menuSubMenuItems === "yes"
                                    ? data?.menuSubMenuTitle
                                    : "000"
                                }
                                `}
                            >
                              <div className={style.text_div}>
                                {res.menuSubSubMenuTitle}
                              </div>
                            </a>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                )
              })}
            </>
          )
        )
      })}

      {/* about */}

      {SubItem?.map(val => {
        return (
          val.resMenuHasLink == "no" && (
            <>
              <ul className={styles.ulList}>
                {val.resMenuSubMenuList?.map(data => {
                  return (
                    <li>
                      <div className={styles.mainListDiv}>
                        <OptimizedImage
                          imageData={data.resSubMenuImage?.mediaItemUrl}
                          alt={data.resMenuSubMenuTitle}
                        />
                        <div className={styles.smallTitle}>
                          {data.resMenuSubMenuTitle}
                        </div>
                        <p className={styles.contentText}>
                          {data.resSubMenuContent}
                        </p>
                        <a
                          className={styles.exploreBtn}
                          href={data.resMenuSubMenuLink?.uri}
                          onClick={e => {
                            e.preventDefault()
                            appNavigate(data.resMenuSubMenuLink?.uri)
                            removeClass()
                          }}
                        >
                          {data.resSubMenuLinkText} <MoreButtonArrowIcon />{" "}
                        </a>
                      </div>
                    </li>
                  )
                })}
              </ul>
            </>
          )
        )
      })}
    </div>
  )
}

export default memo(SubmenuList)
